export default __webpack_public_path__ + "static/media/Boots of Righteous Smiting.f7577978.jpg";